export default "__VITE_ASSET__DoyKS4Ak__"